import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=6cf0a35f&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=6cf0a35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0a35f",
  null
  
)

export default component.exports